export const canvasSelector = '#polymer-editor-canvas';
export const drawnStructuresSelector = '.drawn-structures';
